<div class="action-box">
  <div class="modal-header action-header">
    <div class="action-header-title">
      <h3 class="modal-title">
        <img style="margin-right: .4rem;" [src]="'../../../assets/svg/action-' + (!config.withStatements ? config.action?.frequency > 0 ? 'active.svg':'inactive.svg' : 'active.svg')">
        {{!config.withStatements ? config.action?.task['title'] : config.action['title']}}</h3>
      <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" (click)="close()"
           class="action-header-close-btn">
    </div>
    <p style="white-space: pre-wrap;" id="description"
       [innerHTML]="!config.withStatements ? config.action.task['displayDescription'] : config.action['displayDescription']"></p>
  </div>
  <div *ngIf="config.withStatements" class="action-author-container" style="margin: 1rem 3rem 1rem 3.7rem;">
    <img
      *ngIf="config.action['author']['avatar'] !== null && config.action['author']['avatar']['path'] !== null"
      class="action-user-avatar"
      src="{{config.baseUrl + config.action['author']['avatar']['path']}}">
    <img style="width: 50px" *ngIf="config.action['author']['avatar'] === null"
         src="../../../assets/svg/user-icon.svg" alt="">
    <div class="action-author-name">
      <span [style]="{'font-size' : '11px'}">{{'team_action_assigned_by'|translate}}</span>
      <span>{{ config.action['author']['detail']['displayName'] | getDisplayName: config.action['author']['detail']['firstname'] : config.action['author']['detail']['lastname']: config.action['author']['email']}}</span>
    </div>
    <div class="action-status">
      <span style="font-size: 1.2rem;margin-right: .6rem;">
            {{config.action.status === 'to_do' ? ('insights_action_picked' | translate):
        config.action.status === 'in_progress' ? ('insights_action_started' | translate):
          config.action.status === 'done' ? ('insights_action_completed' | translate):
            config.action.status === 'archived' ? ('insights_action_archived' | translate): ''}}
      </span>
      <span
        style="font-size: 1.2rem; font-weight: bold;">{{(config.action.lastTaskHistory === null ? config.action.created.date : config.action.lastTaskHistory.created.date) | date: 'dd.MM.yyyy'}}</span>
      <div style="margin:0 0 0 1.4rem" class="action-status-dropdown" [ngClass]="selectedActionStatus?.type === 'to_do' ? 'dropdown-todo' :
          selectedActionStatus?.type === 'in_progress' ? 'dropdown-progress':
          selectedActionStatus?.type === 'done' ? 'dropdown-done' :
          selectedActionStatus?.type === 'archived' ? 'dropdown-archived':''">
        <p-dropdown [styleClass]="selectedActionStatus === 'in_progress' ? 'status-in-progress':''" [options]="config.actionsStatus" [(ngModel)]="selectedActionStatus" optionLabel="name" placeholder="{{('team_actions_'+ selectedActionStatus?.type | translate)}}" dropdownIcon="bi bi-chevron-down">
          <ng-template let-status pTemplate="item">
            <div class="status-container" (click)="config.onStatusChange(status)">
              <span>{{status.title}}</span>
              <div [style]="{'background-color':status.color}" class="status-circle-color"></div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
  </div>
  <div [ngClass]="config.withStatements ? 'action-with-statements-body': 'action-body'" class="modal-body">
    <div *ngIf="!config.withStatements" class="solutions-actions">
      <div class="solutions-actions-footer">
        <button *ngIf="data.teamLeaders.length === 1" pButton type="button" label="{{'assign_to_me'|translate}}"
                (click)="!data.showDemo ? close({type: 'assignToMe'}) : ''"
                class="assign-to-button">
        </button>
        <p-dropdown *ngIf="data.teamLeaders.length > 1" [options]="data.teamLeaders" [(ngModel)]="selectedTeamLeader" class="team-type-dropdown" optionLabel="name" placeholder="{{'assign_to' | translate}}" dropdownIcon="bi bi-chevron-down">
          <ng-template let-selectedLeader pTemplate="selectedItem">
            <div class="sort-item sort-item-value" *ngIf="selectedTeamLeader">
              <span>{{ selectedLeader.user.detail.displayName | getDisplayName: selectedLeader.user.detail.firstname: selectedLeader.user.detail.lastname: selectedLeader.user.email }}</span>
              <img class="action-assigned-user-icon"
                   src="{{(selectedLeader.user.avatar !== null && selectedLeader.user.avatar.path !== null) ? data.baseUrl + selectedLeader.user.avatar.path: '../../../assets/svg/user-icon.svg'}}">
            </div>
          </ng-template>
          <ng-template let-leader pTemplate="item">
            <div (click)="!data.showDemo ? close({type: 'assign', member: leader}) : ''">
              <span>{{ leader.user.detail.displayName | getDisplayName: leader.user.detail.firstname: leader.user.detail.lastname: leader.user.email }}</span>
              <img class="action-assigned-user-icon"
                   src="{{(leader.user.avatar !== null && leader.user.avatar.path !== null) ? data.baseUrl + leader.user.avatar.path: '../../../assets/svg/user-icon.svg'}}">
            </div>
          </ng-template>
        </p-dropdown>
        <span (click)="close({type: 'notRelevant'})" style="margin-left: auto; color: #2551BF;"
              class="solution-not-relevant">
          {{'not_relevant'|translate}}</span>
      </div>
    </div>
    <div *ngIf="config.withStatements">
      <span
        class="modal-body-title">{{config.taskStatements.length > 0 ? ('insights_action_linked_to' | translate) : ('insights_action_no_statements' | translate)}}</span>
      <div class="modal-statements" *ngFor="let task of config.taskStatements">
        <img class="modal-statements-icon" src="../../../assets/svg/statement-icon-red.svg">
        <span class="statement-title">{{task.title}}</span>
      </div>
    </div>
  </div>
</div>
